export * from "./ParcelCardDeleteModal";
